import React, { useContext } from "react";
import { BudgetContext } from "../../context/budget.context";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
export default function ExpenseTotal() {
  const { expenses } = useContext(BudgetContext);
  const { t } = useTranslation();
  const totalExpenses = expenses.reduce((total, item) => {
    return (total += item.price);
  }, 0);

  return (
    <div className="alert alert-primary">
      <span>{t("expensetotal")} :{totalExpenses} $ </span>
    </div>
  );
}
